	export enum ClaimsGroupFilterEnum {
		AllClaims = 1,
		EdiQueue = 2,
		PaperQueue = 3
	}
